import { styled } from '@mui/material';

import { spacing } from 'src/constants/spacing';

export const ContentPadding = styled('div')`
  padding: calc(${spacing.smallSpacing} * 2);
  flex-grow: 1;
`;
